/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    fill: #eee;
  }
`

export default function MenuIco() {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" css={Color}>
      <g id="그룹_6957" data-name="그룹 6957" transform="translate(15761.999 12301.999)">
        <rect id="사각형_6570" data-name="사각형 6570" width="22" height="22" transform="translate(-15761.999 -12301.999)" fill="rgba(0,136,255,0)"/>
        <g id="그룹_6954" data-name="그룹 6954">
          <path id="패스_6329" className="fill" data-name="패스 6329" d="M676.833,621.267h-3a2.1,2.1,0,0,1-2.1-2.1v-3a2.1,2.1,0,0,1,2.1-2.1h3a2.1,2.1,0,0,1,2.1,2.1v3A2.1,2.1,0,0,1,676.833,621.267Zm-3-6a.9.9,0,0,0-.9.9v3a.9.9,0,0,0,.9.9h3a.9.9,0,0,0,.9-.9v-3a.9.9,0,0,0-.9-.9Z" transform="translate(-16431.332 -12913.666)"/>
          <path id="패스_6330" className="fill" data-name="패스 6330" d="M676.833,631.267h-3a2.1,2.1,0,0,1-2.1-2.1v-3a2.1,2.1,0,0,1,2.1-2.1h3a2.1,2.1,0,0,1,2.1,2.1v3A2.1,2.1,0,0,1,676.833,631.267Zm-3-6a.9.9,0,0,0-.9.9v3a.9.9,0,0,0,.9.9h3a.9.9,0,0,0,.9-.9v-3a.9.9,0,0,0-.9-.9Z" transform="translate(-16431.332 -12913.666)"/>
          <path id="패스_6331" className="fill" data-name="패스 6331" d="M686.833,621.267h-3a2.1,2.1,0,0,1-2.1-2.1v-3a2.1,2.1,0,0,1,2.1-2.1h3a2.1,2.1,0,0,1,2.1,2.1v3A2.1,2.1,0,0,1,686.833,621.267Zm-3-6a.9.9,0,0,0-.9.9v3a.9.9,0,0,0,.9.9h3a.9.9,0,0,0,.9-.9v-3a.9.9,0,0,0-.9-.9Z" transform="translate(-16431.332 -12913.666)"/>
          <path id="패스_6332" className="fill" data-name="패스 6332" d="M686.833,631.267h-3a2.1,2.1,0,0,1-2.1-2.1v-3a2.1,2.1,0,0,1,2.1-2.1h3a2.1,2.1,0,0,1,2.1,2.1v3A2.1,2.1,0,0,1,686.833,631.267Zm-3-6a.9.9,0,0,0-.9.9v3a.9.9,0,0,0,.9.9h3a.9.9,0,0,0,.9-.9v-3a.9.9,0,0,0-.9-.9Z" transform="translate(-16431.332 -12913.666)"/>
        </g>
      </g>
    </svg>

  )
}
